/**
 * PDP reviews carousel — prev/next + dot paging, and a lightbox for each
 * review's customer photos. Ported from ReviewsCarousel.tsx (variant="pdp").
 */
(function () {
  function initCarousel(section) {
    var viewport = section.querySelector('[data-mel-reviews-viewport]');
    var track = section.querySelector('[data-mel-reviews-track]');
    var prevBtn = section.querySelector('[data-mel-reviews-prev]');
    var nextBtn = section.querySelector('[data-mel-reviews-next]');
    var dotsWrap = section.querySelector('[data-mel-reviews-dots]');
    var navWrap = section.querySelector('[data-mel-reviews-nav]');
    if (!viewport || !track) return;

    function pageCount() {
      return Math.max(1, Math.ceil(track.scrollWidth / viewport.clientWidth));
    }

    function currentPage() {
      return Math.round(viewport.scrollLeft / viewport.clientWidth);
    }

    function renderDots() {
      if (!dotsWrap) return;
      var pages = pageCount();
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        dot.className = 'h-2 w-2 rounded-full transition-all ' + (i === currentPage() ? 'bg-[#0268A0]' : 'bg-[#0268A0]/30 hover:bg-[#0268A0]/50');
        (function (index) {
          dot.addEventListener('click', function () {
            viewport.scrollTo({ left: index * viewport.clientWidth, behavior: 'smooth' });
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }

    function updateNav() {
      var canScroll = track.scrollWidth > viewport.clientWidth + 1;
      if (navWrap) navWrap.classList.toggle('hidden', !canScroll);
      if (prevBtn) prevBtn.disabled = viewport.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = viewport.scrollLeft >= track.scrollWidth - viewport.clientWidth - 1;
      renderDots();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      viewport.scrollTo({ left: viewport.scrollLeft - viewport.clientWidth, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      viewport.scrollTo({ left: viewport.scrollLeft + viewport.clientWidth, behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  function initLightbox(section) {
    var lightbox = section.querySelector('[data-mel-lightbox]');
    var image = section.querySelector('[data-mel-lightbox-image]');
    var counter = section.querySelector('[data-mel-lightbox-counter]');
    var closeBtn = section.querySelector('[data-mel-lightbox-close]');
    var prevBtn = section.querySelector('[data-mel-lightbox-prev]');
    var nextBtn = section.querySelector('[data-mel-lightbox-next]');
    if (!lightbox || !image) return;

    var photos = [];
    var index = 0;

    function render() {
      image.src = photos[index];
      if (counter) counter.textContent = photos.length > 1 ? (index + 1) + ' / ' + photos.length : '';
      var multi = photos.length > 1;
      if (prevBtn) prevBtn.classList.toggle('hidden', !multi);
      if (nextBtn) nextBtn.classList.toggle('hidden', !multi);
    }

    function open(photoList) {
      photos = photoList;
      index = 0;
      render();
      lightbox.classList.remove('hidden');
      lightbox.classList.add('flex');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.classList.add('hidden');
      lightbox.classList.remove('flex');
      document.body.style.overflow = '';
    }

    Array.prototype.slice.call(section.querySelectorAll('[data-mel-review-photo]')).forEach(function (button) {
      button.addEventListener('click', function () {
        var raw = button.getAttribute('data-mel-photos') || '';
        var list = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (list.length) open(list);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      index = (index - 1 + photos.length) % photos.length;
      render();
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      index = (index + 1) % photos.length;
      render();
    });
    document.addEventListener('keydown', function (e) {
      if (lightbox.classList.contains('hidden')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
      if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
    });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mel-reviews-track]')).forEach(function (track) {
      var section = track.closest('section');
      if (!section || section.hasAttribute('data-mel-reviews-bound')) return;
      section.setAttribute('data-mel-reviews-bound', 'true');
      initCarousel(section);
      initLightbox(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
